// extracted by mini-css-extract-plugin
export var locationCard = "_qo-0";